import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@next/core-lib/authorization';

import { ControlRoomComponent } from './control-room/control-room.component';
import { TemplateComponent } from './template/template.component';

export const routes: Routes = [
  {
    path: '',
    component: TemplateComponent,
  },
  {
    path: 'control-room',
    component: ControlRoomComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
    }),
  ],
})
export class AppRoutingModule {}
